<template>
  <div class="">
    <div class="col-md-12">
      <table class="table table-bordered table-striped resultTable ">
        <tbody>
        <tr>
          <td>نام کاربری :</td>
          <th>{{ lists[0]?.name_f }}</th>
          <td> عنوان آزمون:</td>
          <th>{{ lists[0]?.title }}</th>
          <td>زمان کل آزمون:</td>
          <th>{{ lists[0]?.date }}</th>
          <td>تاریخ آزمون:</td>
          <th>{{ converDatePersian(lists[0]?.created_at) }}</th>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="flex-fill bd-highlight panelDiv card mt-2 ">
      <section v-for="(list , index) in lists">
        <div class="justify-content-center align-items-center d-flex">
          <div class="col-lg-4  col-md-4 col-sm-4 "></div>
          <div class="mypanel w-100 ">
            <div class="list-group">
              <h5 class="question">سوال {{ index + 1 }} </h5>
              <h6 class="title"><span style="color:red">*</span>{{ list.question }}</h6>
              <label class="list-group-item list2" :id="`question_one_${list.id}`"
                     :class="{'green-background': list.answers == 'question_one',  'red-background':  list.answers_user_id !== list.answers && list.answers_user_id  ==='question_one' }">
                <div class="justify-content-start">
                  <span :id='`question_one${list.id}`'>1.</span>
                  <input class="form-check-input me-1" type="radio" value="" name="question_first">
                  <span>{{ list.question_one }}</span>
                </div>
              </label>
              <label class="list-group-item list2" :id="`question_two_${list.id}`"
                     :class="{'green-background': list.answers == 'question_two',  'red-background':  list.answers_user_id !== list.answers && list.answers_user_id  ==='question_two' }">
                <div class="justify-content-start">
                  <span :id="`question_two${list.id}`">2.</span>
                  <input class="form-check-input me-1" type="radio" value="" name="question_two">
                  <span>{{ list.question_two }}</span>
                </div>
              </label>
              <label class="list-group-item list2" :id="`question_three_${list.id}`"
                     :class="{'green-background': list.answers == 'question_three',  'red-background':  list.answers_user_id !== list.answers && list.answers_user_id  ==='question_three' }">

                <span :id='`question_three${list.id}`'>3.</span>
                <input class="form-check-input me-1" type="radio" value="" name="question_three">
                <span>{{ list.question_three }}</span>
              </label>
              <label class="list-group-item list2" :id="`question_four_${list.id}`"
                     :class="{'green-background': list.answers == 'question_four',  'red-background':  list.answers_user_id !== list.answers && list.answers_user_id  ==='question_four' }">
                <span :id='`question_four${list.id}`'>4.</span>
                <input class="form-check-input me-1" type="radio" value="" name="question_four">
                <span>{{ list.question_four }}</span>
              </label>
            </div>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-1"></div>
        </div>
      </section>
    </div>
  </div>
</template>
<script setup>
import axios from "axios";
import {useRoute} from "vue-router"
import config from "../../../../config/config.json";
import {converDatePersian} from "@/common/helpers/useFunctionsDate";

const route = useRoute()
let lists = $ref([])

function getLead() {
  axios.get(config.BASE_URL + '/answers/' + route.params.id)
      .then(function (res) {
        if (res.data.status) {
          lists = res.data?.data;
        }
      })
}

getLead()
</script>

